function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 15h26a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2z"
});

var SvgMinus = function SvgMinus(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "c7e60c03d577fbf99dfe004e749dd192.svg";
export { SvgMinus as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/minus.svg
// module id = null
// module chunks = 